import { classValidation } from '../localjs';
import footerLogos from '../widgets/footerLogos.js';
import subPageFooterImages from '../widgetsSubpage/subPageFooterImages.js';

export default function () {
  const $logo = $('.header .logo-container .subpage-logo');
  const $footer = $('.footer .kings-fair-footer');

  $logo.attr('href', subpagePaths.sourcePage);
  customWidgetsSubPage($footer);
  smoothLoad();
}

// function to import widgets and items conditions
function customWidgetsSubPage(element) {
  if (classValidation(subpagePaths.subpageClass)) {
    customLayoutSubPage();
    subPageFooterImages();
    footerLogos('subPageFooterLogos', subPageFooterLogosOpts);
  } else {
    $(element).remove();
  }
}

// function to create classes and elements
function customLayoutSubPage() {
  $('.header ').after(`
        <div class="subpage-banner">
            <h1>the king county fair</h1>
            <span class="abstract-header"></span>
        </div>
        `);

  $('.header, .footer').addClass(subpagePaths.subpageClass);
  $('.footer .footer-subpage-logo').attr('href', subpagePaths.sourcePage);
  $('.footer .main-footer').remove();
}

// function to add smooth loading on elements
function smoothLoad() {
  const themeElements = [
    { selector: '.generalmessage', delay: 100 },
    { selector: '.header', delay: 200 },
    { selector: '.subpage-banner', delay: 500 },
    { selector: '.content', delay: 800 },
    { selector: '.footer', delay: 800 },
  ];

  themeElements.forEach(({ selector, delay }) => {
    setTimeout(() => {
      $(selector).css('opacity', 1);
    }, delay);
  });
}
